import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { linkify } from '@ddv/utils';

import { CrosstalkModalService } from '../../../services/crosstalk-modal.service';

@Component({
    selector: 'app-comment-cell-renderer',
    styleUrls: ['./comment-cell-renderer.component.scss'],
    templateUrl: './comment-cell-renderer.component.html',
    standalone: false,
})
export class CommentCellRendererComponent implements ICellRendererAngularComp {
    private readonly crosstalkModalService = inject(CrosstalkModalService);
    private readonly sanitizer = inject(DomSanitizer);

    comment: SafeHtml | undefined;
    editMode = false;
    private params: ICellRendererParams | undefined;

    get showComment(): boolean {
        return this.params?.value?.length !== 0;
    }

    agInit(params: ICellRendererParams): void {
        this.init(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.init(params);
        return true;
    }

    private getLinkifiedComment(comment: string): string {
        if (!comment) {
            return '';
        }
        return linkify(comment, '_blank');
    }

    private init(params: ICellRendererParams): void {
        this.params = params;

        let linkifiedComment = this.getLinkifiedComment(this.params.value);

        // This disables the hyperlink when in edit mode
        if (params.colDef?.cellEditor) {
            this.editMode = true;
            linkifiedComment = linkifiedComment.replace(/\bhref=/ig, 'rel=');
        } else {
            this.editMode = false;
        }

        this.comment = this.sanitizer.bypassSecurityTrustHtml(linkifiedComment);
    }

    openHistory($event: MouseEvent): void {
        const colId = this.params?.colDef?.field ?? 'THIS SHOULD NEVER HAPPEN';
        const linkConfiguration = { columnId: colId, ...this.params?.data.links[colId] };

        if (linkConfiguration) {
            this.crosstalkModalService.openModal(linkConfiguration, $event, true);
        }

        if ($event.stopImmediatePropagation) {
            $event.stopImmediatePropagation();
        }
    }
}
